var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".linkedin-logo .a{fill:#cdcdce;}")),React.createElement("g",{"transform":"translate(0 0)","key":1},[React.createElement("path",{"className":"a","d":"M402.85,17.839a3.391,3.391,0,1,1-3.391,3.39,3.392,3.392,0,0,1,3.391-3.39Zm-2.925,9.354h5.849V46.011h-5.849Z","transform":"translate(-399.459 -17.839)","key":0}),React.createElement("path",{"className":"a","d":"M432.263,47.507h5.61v2.571h.078a6.145,6.145,0,0,1,5.534-3.039c5.922,0,7.016,3.9,7.016,8.964V66.326h-5.844V57.174c0-2.183-.04-4.99-3.039-4.99-3.044,0-3.51,2.377-3.51,4.832v9.309h-5.844V47.507","transform":"translate(-422.28 -38.153)","key":1})])]);
}

Linkedin.defaultProps = {"width":"28.221","height":"28.172","viewBox":"0 0 28.221 28.172","className":"linkedin-logo"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
